import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import TaskLevelAllocation from './TaskLevelAllocation';
import SecuredProjectRoles from '../../SecuredWorks/SecuredProjectRoles';
// import { getCookie } from '../../Helper/CookieHelper';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
    },
}));

// ((access && access.access && access.access.l14a && access.access.l14a.l14a_a) || this.props.pdm)

export default function TaskLevelTabs(props) {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    //  console.log(props.projectLook)

    return (
        <div className={classes.root}>
            <AppBar position="static">
                <Tabs indicatorColor='secondary' textColor='inherit' value={value} onChange={handleChange} aria-label="simple tabs example">
                    <Tab label="Task Level Allocation" {...a11yProps(0)} />
                    <Tab label="Manage Task Roles" {...a11yProps(1)} />
                    {/* <Tab label="Manage Task Roles" {...a11yProps(2)} /> */}
                </Tabs>
            </AppBar>
            <TabPanel value={value} index={0}>
                <TaskLevelAllocation value={props.value} team={props.team} requestOption={true} projectLook={props.projectLook} />
            </TabPanel>
            <TabPanel value={value} index={1}>
                <SecuredProjectRoles value={props.value} task={props.value} team={props.team} requestOption={true} nonEditable={!props.pdm} rolesLookUp={props.allRoles} projectLook={props.projectLook} />
            </TabPanel>
           
        </div>
    );
}
